import data from './data'
import methods from './methods'

export default {
  data,
  methods,

  /* route API for professional documents */
  resourcePath: '/v1/professional/list'
}



// WEBPACK FOOTER //
// ./src/app/professional/company/documents/resources/index.js